const KL_RATING_SELECTOR = '[data-kl-rating]';
const KL_RATING_STEP_ATTRIBUTE = 'data-kl-rating-step';
const KL_RATING_MAX_STEPS = 10;

function getRatingStep(ratingValue, ratingMax) {
  const value = Number.parseFloat(ratingValue);
  const max = Number.parseFloat(ratingMax);

  if (!Number.isFinite(value) || !Number.isFinite(max) || max <= 0) return 0;

  const normalised = Math.min(Math.max(value / max, 0), 1);

  return Math.round(normalised * KL_RATING_MAX_STEPS);
}

function applyRatingStep(element) {
  if (!element) return;

  try {
    const step = getRatingStep(element.dataset.klRatingValue, element.dataset.klRatingMax);

    element.setAttribute(KL_RATING_STEP_ATTRIBUTE, String(step));
  } catch (error) {
    console.debug('kl-rating: could not apply a rating step', {
      ratingValue: element.dataset.klRatingValue,
      ratingMax: element.dataset.klRatingMax,
      error,
    });
  }
}

function initRatings(root) {
  if (!root) return;

  root.querySelectorAll(KL_RATING_SELECTOR).forEach(applyRatingStep);
}

initRatings(document);

document.addEventListener('shopify:section:load', (event) => {
  initRatings(event.target);
});
